import { EmergencyList } from "./EmergencyList";

export default {
  title: "SecurityPortal/Events/EmergencyList",
  component: EmergencyList,
  decorators: [
    (Story) => (
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          fontFamily: "Helvetica Neue",
          height: "260px",
          width: "554px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <EmergencyList {...args} />;

export const Default = Template.bind({});
Default.args = {
  onUpload: () => alert("onUpload fired."),
  emergencyItems: [
    {
      description: "Active Shooter Plan",
      onClick: () => {
        alert("Clicked 'Active Shooter Plan' Document.");
      },
    },
    {
      description: "Fire Safety and Evacuation Plan",
      onClick: () => {
        alert("Clicked 'Fire Safety and Evacuation Plan' Document.");
      },
    },
    {
      description: "Natural Disaster Plan",
      onClick: () => {
        alert("Clicked 'Natural Disaster Plan' Document.");
      },
    },
  ],
};
